import { FC } from "react";
import { OutlinedButton } from "../../components/Buttons";
import { useTheme } from "@mui/material/styles";
import { styled } from "@mui/material/styles";
import Text from "../../components/Text";

const MainContainer = styled("div")(({ theme }) => ({
  width: "500px",
  margin: "0px auto",
  textAlign: "center",

  marginBottom: "50px",

  [theme.breakpoints.down("sm")]: {
    width: "90%",
  },
}));

const SubContainer = styled("div")(({ theme }) => ({
  width: "100%",
  padding: "30px 20px",
  backgroundColor: theme.palette.primary.main,
  borderRadius: "8px",
  marginTop: "15px",
  textAlign: "left",
}));

const Label = styled("h1")(({ theme }) => ({
  fontSize: "18px",
  fontFamily: "Poppins",
  fontWeight: "500",
  color: theme.palette.background.default,
  marginBottom: "5px",
}));

const VoterProfile: FC = () => {
  const theme = useTheme();

  return (
    <MainContainer>
      <div
        style={{
          fontSize: "50px",
          fontFamily: "Righteous",
          color: theme.palette.primary.main,
          margin: "0px auto",
        }}
      >
        My Profile
      </div>

      <SubContainer>
        <Label>Address: 0x1234567890</Label>

        <Label>Total number of votes: 500</Label>

        <Label>Total votes with majority decision: 400</Label>
        <Label>Total Incentive Earned: 100 Token</Label>
      </SubContainer>
      <Text
        color={theme.palette.primary.main}
        fontSize={16}
        sx={{
          marginTop: "20px",
        }}
      >
        Withdrawal Amount: 100 Token
      </Text>
      <OutlinedButton
        type="submit"
        style={{ width: "calc( 100% - 4px )", marginTop: "20px" }}
      >
        Withdraw
      </OutlinedButton>
      <Text
        color={theme.palette.primary.main}
        fontSize={16}
        sx={{
          marginTop: "20px",
        }}
      >
        Staked Amount: 100 Token
      </Text>
      <OutlinedButton
        type="submit"
        style={{ width: "calc( 100% - 4px )", marginTop: "20px" }}
      >
        Resign as a Voter
      </OutlinedButton>
    </MainContainer>
  );
};

export default VoterProfile;
